export const API_POLLER_SECRETS_ORDER_BY = [
  'last_successful_run',
  'last_run',
  'created_on',
  'modified_on',
  'poller_name',
  'problem_present_since',
  'total_errors',
  'consecutive_errors',
  'number_polled_dlns_total',
  'number_polled_dlns_last_run',
  'last_polled_dln',
  'last_alert_date',
  'description',
  'version',
  'issuer_company',
] as const;
